.wrapper {
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
}

.label {
  font-size: 14px;
  font-weight: 500;
  color: var(--text-secondary);
}

.input {
  background: var(--bg-secondary);
  border: 1px solid #2e2e42;
  border-radius: 8px;
  padding: 12px 16px;
  color: var(--text-primary);
  font-family: inherit;
  font-size: 15px;
  transition: all 0.2s ease;
  outline: none;
}

.input:focus {
  border-color: #6c63ff;
  box-shadow: 0 0 0 2px rgba(108, 99, 255, 0.15);
}

.inputError {
  border-color: #ef4444;
}

.inputError:focus {
  border-color: #ef4444;
  box-shadow: 0 0 0 2px rgba(239, 68, 68, 0.15);
}

.error {
  font-size: 13px;
  color: #ef4444;
}